
/**
 * Module dependencies.
 */

import { handleActions } from 'redux-actions'
import getProp from '@f/get-prop'
import {
  REQUEST_PARTNER_REPORT_URL,
  REQUEST_PARTNER_REPORT_URL_ERROR,
  RECEIVED_PARTNER_REPORT_URL
} from '../actions'

export default handleActions({
  [REQUEST_PARTNER_REPORT_URL] (state, { payload }) {
    const { metadataType, metadataSlug } = payload
    const existingTypes = state[metadataType] || {}
    const existingData = getProp(`${metadataType}.${metadataSlug}`, state)
    return {
      ...state,
      [metadataType]: {
        ...existingTypes,
        [metadataSlug]: {
          ...existingData,
          isRequesting: true,
          didRequestFail: false
        }
      }
    }
  },
  [REQUEST_PARTNER_REPORT_URL_ERROR] (state, { payload }) {
    const { metadataType, metadataSlug } = payload
    const existingTypes = state[metadataType] || {}
    const existingData = getProp(`${metadataType}.${metadataSlug}`, state)
    return {
      ...state,
      [metadataType]: {
        ...existingTypes,
        [metadataSlug]: {
          ...existingData,
          isRequesting: false,
          didRequestFail: true,
          data: null
        }
      }
    }
  },
  [RECEIVED_PARTNER_REPORT_URL] (state, { payload }) {
    const { metadataType, metadataSlug, response } = payload
    const existingTypes = state[metadataType] || {}
    const existingData = getProp(`${metadataType}.${metadataSlug}`, state)
    return {
      ...state,
      [metadataType]: {
        ...existingTypes,
        [metadataSlug]: {
          ...existingData,
          isRequesting: false,
          didRequestFail: false,
          data: response
        }
      }
    }
  }
}, {})



// WEBPACK FOOTER //
// ./reducers/metadata-metrics.js